import { adminResetPassword } from "@api/auth/adminResetPassword";
import { Button, Divider, Stack } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import type { DriverObject } from "@/libs/generated/types";

import { RoutePaths } from "@/utils/constants/routes";

export default function DriverToolBar({ driverData }: { driverData: DriverObject }) {
  const { t } = useTranslation();
  const [forceChangePassword] = useState(false);

  const isDisabled =
    driverData.status === "DISABLED" || (!driverData.status && driverData.disabled);

  return (
    <>
      <Stack spacing={2} direction="row">
        <Button variant="outlined" color="primary">
          <Link
            to={`${
              isDisabled
                ? RoutePaths.adminDriversTabledisabledDriversHistory
                : RoutePaths.adminDriversTableacceptedHistory
            }/${driverData.id}`}
          >
            {t("driver.driver-history")} ({driverData?.nbDeals ?? 0})
          </Link>
        </Button>
        {forceChangePassword && (
          <Button
            variant="outlined"
            color="primary"
            onClick={async () => adminResetPassword({ username: driverData.email })}
          >
            réinitialiser le mot de passe
          </Button>
        )}
      </Stack>
      <Divider sx={{ paddingY: 1 }} />
    </>
  );
}
